"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStateMachineAttr = isStateMachineAttr;
function isStateMachineAttr(attr) {
    return attr?.value.valueType === 'stateMachine';
}
//# sourceMappingURL=stateMachine.guard.js.map